import { render, staticRenderFns } from "./delivery_detail.vue?vue&type=template&id=01af2efa&scoped=true"
import script from "./delivery_detail.vue?vue&type=script&lang=js"
export * from "./delivery_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af2efa",
  null
  
)

export default component.exports